import api from './axiosService';

export const shopOwnerApi = {
    getAll(params = {}) {
        return api.get('/shop-owners', { params });
    },

    getById(shopOwnerId) {
        return api.get(`/shop-owners/${shopOwnerId}`);
    },

    getByShop(shopId, params = {}) {
        return api.get(`/shop-owners/shop/${shopId}`, { params });
    },

    getTotalByShop(shopId) {
        return api.get(`/shop-owners/shop/${shopId}/total`);
    },

    getAvailableOwners(params = {}) {
        return api.get('/shop-owners/available', { params });
    },

    create(data) {
        return api.post('/shop-owners', data);
    },

    update(shopOwnerId, data) {
        return api.put(`/shop-owners/${shopOwnerId}`, data);
    },

    toggleStatus(shopOwnerId) {
        return api.patch(`/shop-owners/${shopOwnerId}/toggle-status`);
    },

    setStatus(shopOwnerId, status) {
        return api.patch(`/shop-owners/${shopOwnerId}/status`, { status });
    },

};